import { useMemo } from 'react';

import { useField, useFormContext } from '../../../forms/orderForm';
import { isRequiredAdditionalParameters } from '../../../helpers';

export const useAdditionalParametersSection = () => {
  const { values } = useFormContext();

  const isRequired = isRequiredAdditionalParameters(values);

  const { helpers: transactionDateHelpers } = useField(
    'additionalParameters.transactionDate'
  );
  const { helpers: settlementDateHelpers } = useField(
    'additionalParameters.settlementDate'
  );

  useMemo(() => {
    if (!isRequired) {
      transactionDateHelpers.setValue(null);
      transactionDateHelpers.setError(undefined);
      settlementDateHelpers.setValue(null);
      settlementDateHelpers.setError(undefined);
    }
  }, [isRequired, settlementDateHelpers, transactionDateHelpers]);

  return { isRequired };
};
